module.exports = {"status":"Sorry, we're experiencing some issues with our services. Please come back later."}


//////////////////
// WEBPACK FOOTER
// ./src/components/Status/locales/en.json
// module id = 2001
// module chunks = 0